import PropTypes from 'prop-types';
import React from 'react';
import styles from './index.module.scss';

export default class extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    tabs: PropTypes.arrayOf(PropTypes.string).isRequired,
    onChangeTab: PropTypes.func.isRequired,
  };

  static defaultProps = {
    className: '',
  };

  state = {
    selectedIndex: 0,
  };

  handleSelectTab = index => {
    if (this.state.selectedIndex !== index) {
      this.setState({ selectedIndex: index });
      this.props.onChangeTab(index);
    }
  };

  render() {
    const { className, tabs } = this.props;
    const { selectedIndex } = this.state;

    return (
      <ul className={`${styles.root} ${className || ''}`}>
        {tabs.map((tab, index) => (
          <li
            key={index}
            className={selectedIndex === index ? styles.active : ''}
            onClick={() => this.handleSelectTab(index)}
          >
            {tab}
          </li>
        ))}
      </ul>
    );
  }
}
